import { createSelector } from '@reduxjs/toolkit'
import { hasModalDialog as hasMessagesDialog } from 'archiving/messages/subs'

export const hasModalDialog = createSelector(
  hasMessagesDialog,
  (hasMessagesDialog) => hasMessagesDialog
)
